<template>
    <section class="page-section" v-loading="pageLoading">
                <div class="form-wrap">
                    <el-form size="small" ref="formData" :model="formData" label-width="80px" class="content-form">
                        <el-form-item label="一级分类" required :show-message="false">
                            <div>
                                <el-input v-model="formData.name" class="w150" maxlength="4" placeholder="2-4个中文字符" @blur="handleValidFirstTitle(formData.name)"></el-input>
                            </div>
                        </el-form-item>

                        <div class="delete-block" style="background: #FFF;" v-for="(cItem, cIndex) in formData.categoryList" :key="cIndex">
                            <div class="icon-delete" @click="handleCategoryDelete(cIndex)" v-if="formData.categoryList.length > 1"></div>
                            <el-form-item label="二级分类" required :show-message="false" class="no-margin">
                                <div>
                                    <el-input v-model="cItem.name" class="w150" maxlength="6" placeholder="2-6个中文字符" @blur="handleValidSecondTitle(cItem.name)"></el-input>
                                    <el-button type="text" size="small" v-if="cItem.visible" @click="cItem.visible = !cItem.visible">收起分类</el-button>
                                    <el-button type="text" size="small" v-else @click="cItem.visible = !cItem.visible">展开分类</el-button>
                                </div>
                            </el-form-item>
                            <el-form-item label="" :show-message="false" class="no-label" style="margin-bottom: 0;">
                                <el-collapse-transition>
                                    <div v-if="cItem.visible">
                                        <div class="delete-block no-bg" v-for="(labelItem, labelIndex) in cItem.labels" :key="labelIndex">
                                            <div class="block-item flex-h">
                                                <div class="label margin-right-10" style="white-space: nowrap;"><span class="required-icon"></span> 关联{{ catType == 1 ? '商品' : '项目' }}</div>
                                                <div class="flex-a-i">
                                                    <!-- 商品 -->
                                                    <template v-if="catType == 1">
                                                        <div class="flex-h">
                                                            <div class="flex-a-i">
                                                                <el-button type="text" size="small" style="margin-left: 0;" @click="handleRelatedGoodsDialogShow(cIndex, labelIndex)">关联{{ catType == 1 ? '商品' : '项目' }}</el-button>
                                                            </div>
                                                            <div v-if="labelItem.commodityList && labelItem.commodityList.page && labelItem.commodityList.page.total > 0">
                                                                <el-pagination
                                                                    small
                                                                    layout="total"
                                                                    :total="labelItem.commodityList.page.total">
                                                                </el-pagination>
                                                            </div>
                                                        </div>

                                                        <el-table size="small" :data="labelItem.commodityList.tableData" v-loading="labelItem.commodityList.tableLoading" v-if="labelItem.commodityList.tableData.length > 0" :class="'table-' + cIndex + '-' + labelIndex">
                                                            <el-table-column label="商品" width="400">
                                                                <template slot-scope="scope">
                                                                    <div class="dialog-goods-title">
                                                                        <div class="thumb-wrap">
                                                                            <img :src="scope.row.mainPic" style="pointer-events: none;">
                                                                        </div>
                                                                        <p>{{ scope.row.name }}<span style="color: red;" v-if="scope.row.status == 2">（已售罄）</span></p>
                                                                        <p>¥{{ scope.row.price }}</p>
                                                                    </div>
                                                                </template>
                                                            </el-table-column>
                                                            <el-table-column label="商品分类">
                                                                <template slot-scope="scope">
                                                                    <p v-for="(item, index) in scope.row.category" :key="index">{{ item }}</p>
                                                                </template>
                                                            </el-table-column>
                                                            <el-table-column label="库存" width="80">
                                                                <template slot-scope="scope">
                                                                    <p>{{ scope.row.stock }}</p>
                                                                </template>
                                                            </el-table-column>
                                                            <el-table-column label="总销量" width="60">
                                                                <template slot-scope="scope">
                                                                    <p>{{ scope.row.sale || '-' }}</p>
                                                                </template>
                                                            </el-table-column>
                                                            <el-table-column label="操作" width="80" align="right">
                                                                <template slot-scope="scope">
                                                                    <el-button size="small" type="text" @click="handleCommodityListRowRemove(scope.row, scope.$index, cIndex, labelIndex)">解除关联</el-button>
                                                                </template>
                                                            </el-table-column>
                                                        </el-table>
                                                    </template>
                                                    <!-- 服务 -->
                                                    <template v-if="catType == 2">
                                                        <div class="flex-h">
                                                            <div class="flex-a-i" style="margin-right: 40px">
                                                                <el-select v-model="labelItem.commodityIds" multiple filterable style="width: 100%" placeholder="请选择" @change="handleGetRelatedGoodsList(cIndex, labelIndex)">
                                                                    <el-option v-for="item in serviceOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                                                </el-select>
                                                            </div>
                                                            <div v-if="labelItem.commodityList && labelItem.commodityList.page && labelItem.commodityList.page.total > 0">
                                                                <el-pagination
                                                                    small
                                                                    layout="total"
                                                                    :total="labelItem.commodityList.page.total">
                                                                </el-pagination>
                                                            </div>
                                                        </div>
                                                        <el-table class="margin-top-10" size="small" :data="labelItem.commodityList.tableData" v-loading="labelItem.commodityList.tableLoading" v-if="labelItem.commodityList.tableData.length > 0" :class="'table-' + cIndex + '-' + labelIndex">
                                                            <el-table-column label="项目" width="400">
                                                                <template slot-scope="scope">
                                                                    <div class="dialog-goods-title">
                                                                        <div class="thumb-wrap">
                                                                            <img :src="scope.row.pic" style="pointer-events: none;">
                                                                        </div>
                                                                        <p>{{ scope.row.name }}<span style="color: red;" v-if="scope.row.status == 2">（已售罄）</span></p>
                                                                        <p>备注：{{ scope.row.remark }}</p>
                                                                    </div>
                                                                </template>
                                                            </el-table-column>
                                                            <el-table-column label="价格(人民币)" sortable sort-by="price">
                                                                <template slot-scope="scope">
                                                                    <p>￥{{ scope.row.price }}</p>
                                                                    <p style="text-decoration: line-through;" v-if="scope.row.linePrice">￥{{ scope.row.linePrice }}</p>
                                                                </template>
                                                            </el-table-column>
                                                            <el-table-column label="价格(韩元)" sortable sort-by="koreaPrice">
                                                                <template slot-scope="scope">
                                                                    <p>₩{{ scope.row.koreaPrice }}</p>
                                                                    <p style="text-decoration: line-through;" v-if="scope.row.lineKoreaPrice">₩{{ scope.row.lineKoreaPrice }}</p>
                                                                </template>
                                                            </el-table-column>
                                                            <el-table-column label="库存" width="80">
                                                                <template slot-scope="scope">
                                                                    <p>{{ scope.row.stock }}</p>
                                                                </template>
                                                            </el-table-column>
                                                            <el-table-column label="总销量" width="60">
                                                                <template slot-scope="scope">
                                                                    <p>{{ scope.row.saleNum > 0 ? scope.row.saleNum : '-' }}</p>
                                                                </template>
                                                            </el-table-column>
                                                            <el-table-column label="操作" width="80" align="right">
                                                                <template slot-scope="scope">
                                                                    <el-button size="small" type="text" @click="handleCommodityListRowRemove(scope.row, scope.$index, cIndex, labelIndex)">解除关联</el-button>
                                                                </template>
                                                            </el-table-column>
                                                        </el-table>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </el-collapse-transition>
                            </el-form-item>
                        </div>

                        <el-button type="default" size="small" plain @click="handleCategoryAdd">添加二级分类</el-button>

                        <div class="margin-top-15">
                            <el-button type="primary" size="small" :loading="submitLoading" @click="handleSave">保存</el-button>
                            <el-button type="default" size="small" plain @click="pageLinkToComponentList">取消</el-button>
                        </div>
                    </el-form>
                </div>
            

        <!-- 关联商品 弹窗 -->
        <DialogGoods :ids="relatedDialog.ids" ref="goodsRelate" @ids="getRelatedGoodsIds"></DialogGoods>
      </section>
</template>

<script>
    import { COMMON, serviceManageList, moduleCategoryDetail, moduleCategorySave, validShopProps, commodityFilterList } from '@/common/api';
    import DialogGoods from '@/components/dialog/goods.vue'

    export default {
        name: 'shopComponentCategoryAdd',
        components: {
            DialogGoods
        },
        data() {
            return {
                id: this.$route.query.id || '',
                catType: this.$route.query.catType || '',

                pageLoading: false, // 页面loading

                secondCategoryVos: [],

                formData: {
                    name: '', // 一级分类名
                    categoryList: [
                        {
                            name: '',
                            visible: true,
                            labels: [
                                {
                                    pics: [],
                                    name: '',
                                    commodityIds: [],
                                    commodityList: {
                                        tableLoading: false,
                                        tableData: [],
                                        page: {
                                            current: 1,
                                            size: 9999,
                                            total: 0
                                        }
                                    }
                                }
                            ]
                        }
                    ]
                },
                serviceLoading: true,
                serviceOptions: [], // 服务列表
                'relatedDialog': { // 关联商品弹窗
                    'cateIndex': '', // 二级分类序号
                    'labelIndex': '', // 标签序号
                    'ids': [] // id集合
                },
                submitLoading: false
            }
        },
        methods: {
            /**
             * [getServiceList description] 获取表格数据
             * @return {[type]} [description]
             */
            getServiceList: function() {
                this.serviceLoading = true;

                let params = {
                    current: 1,
                    size: 99999
                }

                serviceManageList(params).then(res =>{
                    this.serviceLoading = false;

                    let { code, data, msg } = res;

                    if(code == 0) {
                        let dataArray = data.records || [];

                        this.serviceOptions = dataArray;
                        this.$forceUpdate()
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [handleValidFirstTitle description] 校验一级分类是否重复
             * @return {[type]} [description]
             */
            handleValidFirstTitle: function(value) {
                let params = {
                    catType: this.catType,
                    id: this.id,
                    type: 2,
                    name: value,
                    second: 0
                }

                validShopProps(params).then(res =>{
                    let { code, data, msg } = res;

                    if(code != 0) {
                        this.$message.error(msg);
                    }
                });
            },
            /**
             * [handleValidSecondTitle description] 校验二级分类是否重复
             * @return {[type]} [description]
             */
            handleValidSecondTitle: function(value) {
                let params = {
                    catType: this.catType,
                    id: this.id,
                    type: 2,
                    name: value,
                    second: 1
                }

                validShopProps(params).then(res =>{
                    let { code, data, msg } = res;

                    if(code != 0) {
                        this.$message.error(msg);
                    }
                });
            },
            /**
             * [getDetail description] 获取详情
             * @param  {[type]} val [description]
             * @return {[type]}     [description]
             */
            getDetail: function() {
                if(!this.id) {
                    this.pageLoading = false;
                    return false;
                }

                this.pageLoading = true;

                let params = {
                    catType: this.catType,
                    id: this.id
                }

                moduleCategoryDetail(params).then(res =>{
                    this.pageLoading = false;

                    let { code, data, msg } = res;

                    if(code == 0) {
                        this.secondCategoryVos = data.secondCategoryVos;

                        this.formData.name = data.name;
                        this.formData.useAd = '' + data.useAd;
                        this.formData.pics = [];

                        let categoryList = [];
                        if(data.secondCategoryVos.length > 0) {
                            for(let i = 0; i < data.secondCategoryVos.length; i++) {
                                let cItem = data.secondCategoryVos[i],
                                    labels = [];

                                if(cItem.categoryLabelVos.length > 0) {
                                    for(let j = 0; j < cItem.categoryLabelVos.length; j++) {
                                        let labelItem = cItem.categoryLabelVos[j];

                                        labels.push({
                                            pics: [],
                                            name: labelItem.name,
                                            commodityIds: labelItem.commodityIds,
                                            commodityList: {
                                                tableLoading: false,
                                                tableData: [],
                                                page: {
                                                    current: 1,
                                                    size: 9999,
                                                    total: 0
                                                }
                                            }
                                        })
                                    }
                                }

                                categoryList.push({
                                    name: cItem.name,
                                    visible: true,
                                    labels: labels
                                })

                            }
                        }
                        this.formData.categoryList = categoryList;

                        this.formData.categoryList.map((cateItem, cateIndex) => {
                            cateItem.labels.map((labelItem, labelIndex) => {
                                this.handleGetRelatedGoodsList(cateIndex, labelIndex);
                            });
                        });

                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    console.log(error)
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [handleCategoryAdd description] 二级分类 - 添加
             * @return {[type]} [description]
             */
            handleCategoryAdd: function() {
                this.formData.categoryList.push({
                    name: '',
                    visible: true,
                    labels: [
                        {
                            pics: [],
                            name: '',
                            commodityIds: [],
                            commodityList: {
                                tableLoading: false,
                                tableData: [],
                                page: {
                                    current: 1,
                                    size: 9999,
                                    total: 0
                                }
                            }
                        }
                    ]
                });
            },
            /**
             * [handleCategoryDelete description] 二级分类 - 删除
             * @param  {[type]} index [description]
             * @return {[type]}       [description]
             */
            handleCategoryDelete: function(index) {
                this.formData.categoryList.splice(index, 1);
            },
            // ==============================================================================================================================
            /**
             * [handleRelatedGoodsDialogShow description] 指定商品 - 弹窗 - 显示
             * @return {[type]} [description]
             */
            handleRelatedGoodsDialogShow: function(cateIndex, labelIndex) {
                this.relatedDialog.cateIndex = cateIndex;
                this.relatedDialog.labelIndex = labelIndex;
                this.relatedDialog.ids = JSON.parse(JSON.stringify(this.formData.categoryList[cateIndex].labels[labelIndex].commodityIds));
                this.$refs.goodsRelate.handleDialogShow();
            },
            /**
             * [getRelatedGoodsIds description] 指定商品 - 弹窗 - 选中的数据id集合
             * @param  {[type]} ids [description]
             * @return {[type]}     [description]
             */
            getRelatedGoodsIds: function(ids) {
                this.formData.categoryList[this.relatedDialog.cateIndex].labels[this.relatedDialog.labelIndex].commodityIds = ids;
                this.handleGetRelatedGoodsList(this.relatedDialog.cateIndex, this.relatedDialog.labelIndex);
            },
            /**
             * [handleGetRelatedGoodsList description] 指定商品 - 根据选中数据的id集合获取商品列表
             * @return {[type]} [description]
             */
            handleGetRelatedGoodsList: function(cateIndex, labelIndex) {
                let labelItem = this.formData.categoryList[cateIndex].labels[labelIndex];

                if(labelItem.commodityIds.length === 0) {
                    return false
                }

                labelItem.commodityList.tableLoading = true;

                if(this.catType == 1) {
                    // 商品
                    let params = {
                        catType: this.catType,
                        idStr: labelItem.commodityIds.join(','),
                        current: labelItem.commodityList.page.current,
                        size: labelItem.commodityList.page.size
                    }
                    commodityFilterList(params).then(res =>{
                        labelItem.commodityList.tableLoading = false;

                        let { code, data, msg } = res;

                        if(code == 0) {
                            let dataArray = data.records || [];

                            dataArray.map((item, index) => {
                                if(!item) {
                                    dataArray.splice(index, 1);
                                }
                            })

                            labelItem.commodityList.tableData = dataArray;
                            labelItem.commodityList.page.total = data.total;

                            // this.$nextTick(() => {
                            //     this.handleTableRowSort(cateIndex, labelIndex);
                            // });
                        } else {
                            this.$message.error(msg);
                        }
                    }).catch(error => {
                        this.$message.error('服务器异常');
                    });
                } else if(this.catType == 2) {
                    // 服务
                    let params = {
                        idStr: labelItem.commodityIds.join(','),
                        current: labelItem.commodityList.page.current,
                        size: labelItem.commodityList.page.size
                    }
                    serviceManageList(params).then(res =>{
                        labelItem.commodityList.tableLoading = false;

                        let { code, data, msg } = res;

                        if(code == 0) {
                            let dataArray = data.records || [];

                            dataArray.map((item, index) => {
                                if(!item) {
                                    dataArray.splice(index, 1);
                                }
                            })

                            labelItem.commodityList.tableData = dataArray;
                            labelItem.commodityList.page.total = data.total;

                            // this.$nextTick(() => {
                            //     this.handleTableRowSort(cateIndex, labelIndex);
                            // });
                        } else {
                            this.$message.error(msg);
                        }
                    }).catch(error => {
                        this.$message.error('服务器异常');
                    });
                }
            },
            /**
             * [handleCommodityListPageChange description] 指定商品 - 列表 - 切换分页
             * @param  {[type]} val [description]
             * @return {[type]}     [description]
             */
            handleCommodityListPageChange: function(val) {
                // this.commodityList.page.current = val;
                // this.handleGetRelatedGoodsList();
            },
            /**
             * [handleCommodityListRowRemove description] 指定商品 - 列表 - 移除
             * @param  {[type]} row   [description]
             * @param  {[type]} index [description]
             * @return {[type]}       [description]
             */
            handleCommodityListRowRemove: function(row, index, cateIndex, labelIndex) {
                let labelItem = this.formData.categoryList[cateIndex].labels[labelIndex],
                    tableData = labelItem.commodityList.tableData,
                    ids = labelItem.commodityIds;

                tableData.splice(index, 1);
                ids.splice(ids.indexOf(row.id), 1);
                labelItem.commodityList.page.total -= 1;
            },
            // ==============================================================================================================================
            /**
             * [handleSave description] 保存
             * @return {[type]} [description]
             */
            handleSave: function() {
                if(this.handleValidateForm()) {
                    let cateList = this.formData.categoryList,
                        secondCategoryDtoList = [];

                    for(let i = 0; i < cateList.length; i++) {
                        let cateItem = cateList[i],
                            labels = [];

                        for(let j = 0; j < cateItem.labels.length; j++) {
                            let labelItem = cateItem.labels[j];

                            labels.push({
                                name: '默认标签',
                                picUrl: '',
                                commodityIds: labelItem.commodityIds
                            })
                        }

                        secondCategoryDtoList.push({
                            name: cateItem.name,
                            labels: labels
                        })
                    }


                    this.submitLoading = true;

                    let params = {
                        catType: this.catType,
                        id: this.id,
                        name: this.formData.name,
                        useAd: 0,
                        picUrl: '',
                        secondCategoryDtoList: secondCategoryDtoList
                    }

                    moduleCategorySave(JSON.stringify(params)).then(res =>{
                        this.submitLoading = false;

                        let { code, data, msg } = res;

                        if(code == 0) {
                            this.$message({ message: '保存成功', type: 'success' });

                            this.$router.push({ path: '/shop/component/list', query: { name: this.catType == 1 ? 2 : 1 } });
                        } else {
                            this.$message.error(msg);
                        }
                    }).catch(error => {
                        this.submitLoading = false;
                        this.$message.error('服务器异常');
                    });
                }
            },
            /**
             * [handleValidateForm description] 表单校验
             * @return {[type]} [description]
             */
            handleValidateForm: function() {
                if(!this.formData.name) {
                    this.$message.error('请输入一级分类');
                    return false;
                }
                if(this.formData.name.length < 2 || this.formData.name.length > 4) {
                    this.$message.error('一级分类请输入2-4个中文字符');
                    return false;
                }

                let cateList = this.formData.categoryList;
                if(cateList.length == 0) {
                    this.$message.error('请添加二级分类');
                    return false;
                }
                for(let i = 0; i < cateList.length; i++) {
                    let cateItem = cateList[i];

                    if(!cateItem.name) {
                        this.$message.error('请输入二级分类');
                        return false;
                    }
                    if(cateItem.name.length < 2 || cateItem.name.length > 6) {
                        this.$message.error('二级分类请输入2-6个中文字符');
                        return false;
                    }
                }

                return true;
            },
            /**
             * [pageLinkToComponentList description] 取消
             * @return {[type]} [description]
             */
            pageLinkToComponentList: function() {
                this.$router.push({ path: '/shop/component/list', query: { name: this.catType == 1 ? 2 : 1 } });
            },


            /**
             * [handleTableRowSort description] 给表格每一行绑定移动事件
             * @return {[type]} [description]
             */
            handleTableRowSort: function(cateIndex, labelIndex) {
                let wrapClass = 'table-' + cateIndex + '-' + labelIndex,
                    tableWrap = document.getElementsByClassName(wrapClass),
                    table = tableWrap[0].getElementsByClassName('el-table__body');

                if(!table[0]) {
                    return false;
                }

                for(let j = 0; j < table.length; j++) {
                    let tableTR = table[j].getElementsByTagName('tr');

                    for(let i = 0; i < tableTR.length; i++) {
                        tableTR[i].draggable = false;
                        tableTR[i].style.cursor = 'auto';
                        tableTR[i].removeEventListener('dragstart', this.handleTableTRDragStart);
                        tableTR[i].removeEventListener('dragover', this.handleTableTRDragover);
                        tableTR[i].removeEventListener('drop', this.handleTableTRDrop);
                    }

                    for(let i = 0; i < tableTR.length; i++) {
                        let tableTRItem = tableTR[i];
                        
                        tableTRItem.draggable = true;
                        tableTRItem.setAttribute('data-cateindex', cateIndex);
                        tableTRItem.setAttribute('data-labelindex', labelIndex);
                        tableTRItem.setAttribute('data-index', i);
                        tableTRItem.style.cursor = 'all-scroll';

                        tableTRItem.addEventListener('dragstart', this.handleTableTRDragStart, false);
                        tableTRItem.addEventListener('dragover', this.handleTableTRDragover, false);
                        tableTRItem.addEventListener('drop', this.handleTableTRDrop, false);
                    }
                }
            },
            /**
             * [handleTableTRDragStart description] 拖动开始，设置携带的参数
             * @param  {[type]} ev [description] 拖动对象
             * @return {[type]}    [description]
             */
            handleTableTRDragStart: function(ev) {
                ev.dataTransfer.setData('index', ev.target.dataset.index);
                ev.dataTransfer.setData('cateindex', ev.target.dataset.cateindex);
                ev.dataTransfer.setData('labelindex', ev.target.dataset.labelindex);
            },
            /**
             * [handleTableTRDragover description] 必须要 preventDefault, 否则不会触发 drop
             * @param  {[type]} ev [description]
             * @return {[type]}    [description]
             */
            handleTableTRDragover: function(ev) {
                ev.preventDefault();
            },
            /**
             * [handleTableTRDrop description] 拖动释放触发的方法
             * @param  {[type]} ev [description] 目标对象
             * @return {[type]}    [description]
             */
            handleTableTRDrop: function(ev) {
                ev.preventDefault();

                let originalIndex = ev.dataTransfer.getData('index'),
                    originalCateIndex = ev.dataTransfer.getData('cateindex'),
                    originalLabelIndex = ev.dataTransfer.getData('labelindex'),
                    trNode = this.handleGetTRNode(ev.target),
                    targetIndex = trNode.getAttribute('data-index'),
                    targetCateIndex = trNode.getAttribute('data-cateindex'),
                    targetLabelIndex = trNode.getAttribute('data-labelindex');

                if(originalCateIndex !== targetCateIndex || originalLabelIndex !== targetLabelIndex || originalIndex == targetIndex) {
                    // 模块不对应 || 原地释放
                    return false;
                }
                
                // 将移动的对象插入目标对象之前
                let labelItem = this.formData.categoryList[originalCateIndex].labels[originalLabelIndex],
                    originalObject = labelItem.commodityList.tableData.splice(originalIndex, 1),
                    originalId = labelItem.commodityIds.splice(originalIndex, 1);
                labelItem.commodityList.tableData.splice(targetIndex, 0, originalObject[0]);
                labelItem.commodityIds.splice(targetIndex, 0, originalId[0]);

                // do request
                this.handleGetRelatedGoodsList(originalCateIndex, originalLabelIndex);
            },
            /**
             * [handleGetTRNode description] 循环查找dom父节点，直到匹配到tr
             * @param  {[type]} ob [description] 当前dom节点
             * @return {[type]}    [description]
             */
            handleGetTRNode: function(ob) {
                if(ob.tagName == 'TR') {
                    return ob;
                } else {
                    return this.handleGetTRNode(ob.parentNode);
                }            
            }
        },
        mounted() {
            this.getDetail();
            this.getServiceList();
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../../common/styles/base/mixin-font";
    @import "../../../common/styles/base/mixin-common";

    .thumb-wrap{
        position: relative;
        display: inline-block;
        margin-right: 10px;
        vertical-align: middle;
        width: 48px;
        height: 48px;
        background-color: $colorPageBg;

        img{
            max-width: 100%;
            max-height: 100%;
            @include position(absolute, 1, 50%, none, none, 50%);
            @include translate(-50%, -50%, 0);
        }
    }

    .form-wrap{
        padding: 10px 35px;
        background: $colorPageBg;
    }

    .block-item{
        .label{
            width: 5em;
            text-align: right;

            .required-icon{
                color: #F56C6C;
            }
        }
    }

    .pics-box{
        ::v-deep .el-upload-list--picture-card{
            .el-upload-list__item{
                position: relative;
                width: 100px;
                height: 100px;
                border-radius: 2px;

                .el-upload-list__item-thumbnail{
                    @include position(absolute, none, 50%, none, none, 50%);
                    @include translate(-50%, -50%, 0);
                }

                .el-progress{
                    width: 80px;
                    height: 80px;

                    .el-progress-circle{
                        width: 80px !important;
                        height: 80px !important;
                    }
                }

                .el-icon-close-tip{
                    display: none;
                }
            }
        }

        ::v-deep .el-upload--picture-card{
            width: 100px;
            height: 100px;
            line-height: 98px;
            border-radius: 2px;

            .el-upload-dragger{
                width: 98px;
                height: 98px;
                border: none;

                .el-icon-plus{
                    font-size: $baseFS;
                }
            }
        }
    }

    .category-pics-box{
        .pics-box{
            width: 100px;
            height: 100px;
            overflow: hidden;
        }
    }

    .label-pics-box{
        .pics-box{
            width: 70px;
            height: 70px;
            overflow: hidden;

            ::v-deep .el-upload-list--picture-card{
                .el-upload-list__item{
                    width: 70px;
                    height: 70px;

                    .el-progress{
                        width: 560px;
                        height: 56px;

                        .el-progress-circle{
                            width: 56px !important;
                            height: 56px !important;
                        }
                    }
                }
            }

            ::v-deep .el-upload--picture-card{
                width: 70px;
                height: 70px;
                line-height: 68px;

                .el-upload-dragger{
                    width: 68px;
                    height: 68px;
                }
            }
        }
    }
</style>

